import { BodyFileNodeView } from "@/components/rich-editor/components/BodyFileNodeView.tsx";
import { dataAttribute } from "@/components/rich-editor/extensions/body-file-node.helpers.ts";
import { mergeAttributes, Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";

export const Pdf = Node.create({
  name: "pdf",
  group: "block",
  atom: true,
  draggable: true,

  addAttributes() {
    return {
      fileUuid: dataAttribute("fileUuid", "data-file-uuid"),
      fileName: dataAttribute("fileName", "data-file-name"),
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="pdf"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes({ "data-type": "pdf" }, HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(BodyFileNodeView);
  },
});
